import { render } from "./AboutUsPa.vue?vue&type=template&id=717aeb82&scoped=true"
import script from "./AboutUsPa.vue?vue&type=script&lang=js"
export * from "./AboutUsPa.vue?vue&type=script&lang=js"

import "./AboutUsPa.vue?vue&type=style&index=0&id=717aeb82&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-717aeb82"]])

export default __exports__